import { connect } from 'react-redux';
import React from 'react';
import Dialog from 'src/components/common/Dialog';
import DialogList from 'src/dialogs';
import { AnyObject } from 'final-form';
import actions from 'src/actions';
import Form from 'src/components/controls/forms/Form';
import FormTextBox from 'src/components/controls/forms/redesign/FormTextbox';
import Button from 'src/components/controls/forms/redesign/FormButton';

interface IVoidAgreementDialogOwnProps {
    voidAgreement: (reason: string) => void;
}

interface IVoidAgreementDispatchProps {
    hideDialog: () => void;
}

type IVoidAgreementProps = IVoidAgreementDialogOwnProps & IVoidAgreementDispatchProps;

const VoidAgreementDialog: React.FC<IVoidAgreementProps> = (props) => {
    const onSubmit = (values: AnyObject) => {
        props.voidAgreement(values.reason);
        props.hideDialog();
    };

    return (
        <>
            <Dialog dialogName={DialogList.VOID_AGREEMENT} title="Void Contract">
                <div>
                    <Form onSubmit={onSubmit}>
                        <FormTextBox name="reason" label="Explanation" />
                        <Button text="OK" type="submit" />
                    </Form>
                </div>
            </Dialog>
        </>
    );
};

const mapDispatchToProps: IVoidAgreementDispatchProps = {
    hideDialog: () => actions.layout.hideDialog(),
};

export default connect(null, mapDispatchToProps)(VoidAgreementDialog);



// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/VoidAgreementDialog.tsx